import { ComponentClass } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { ResourceGovernanceOwnProps, ResourceGovernanceStateProps, ResourceGovernanceSubspace,ResourceGovernanceSubspaceDispatchProps } from './ResourceGovernanceSubspace';


const mapStateToProps: MapStateToProps<ResourceGovernanceStateProps> = (state: AppState) => ({
  isFirstRun: state.contentExplorer.content.contentItems.length === 0,
});
const mapDispatchToProps: MapDispatchToProps<ResourceGovernanceSubspaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents: requestSpaceContents
}, dispatch);

export const ConnectedResourceGovernanceSubspace: ComponentClass<ResourceGovernanceOwnProps> = connect(mapStateToProps, mapDispatchToProps)(ResourceGovernanceSubspace);
